import React, { useState } from "react";
import { X } from "lucide-react";
import { apiClient } from "../api/apiClient";

const inputClass =
  "w-full px-4 py-2 rounded-lg bg-bg-soft border border-border focus:outline-none focus:ring-2 focus:ring-accent text-text-primary placeholder:text-text-muted transition";

export default function UserInfoModal({ isOpen, onClose }) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [organisation, setOrganisation] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await apiClient.post("/request-demo", {
        name,
        email,
        organisation,
        message,
      });

      console.log("Demo request submitted:", res.data);

      setName("");
      setEmail("");
      setOrganisation("");
      setMessage("");

      onClose();
    } catch (err) {
      console.error("Error submitting demo request:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50"
      onClick={onClose}
    >
      {/* Modal Box */}
      <div
        className="bg-white border border-border text-text-primary p-8 rounded-xl shadow-xl w-[90%] max-w-md relative"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-text-muted hover:text-text-primary transition"
        >
          <X size={22} />
        </button>

        <h2 className="text-2xl font-bold mb-2 text-text-primary">Ready to migrate?</h2>
        <p className="text-text-secondary mb-6">
          Fill in your details and we'll get back to you.
        </p>

        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            type="text"
            placeholder="Your Name"
            className={inputClass}
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />

          <input
            type="email"
            placeholder="Your Email"
            className={inputClass}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <input
            type="text"
            placeholder="Organisation"
            className={inputClass}
            value={organisation}
            onChange={(e) => setOrganisation(e.target.value)}
            required
          />

          <textarea
            placeholder="Message (optional)"
            rows="3"
            className={`${inputClass} resize-none`}
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-primary text-white py-2 rounded-lg font-bold hover:bg-primary-soft transition disabled:opacity-70"
          >
            {loading ? "Submitting..." : "Submit"}
          </button>
        </form>
      </div>
    </div>
  );
}